import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import Games from "./Pages/Games";
import ErrorPage from "./Pages/ErrorPage";
import Calculator from "./Pages/Calculator";
import Virtual from "./Pages/Virtual";
import BirthdayPage from "./Pages/BirthdayPage";
import ComingSoon from "./Pages/ComingSoon";
import TurningPage from "./Pages/TurningPage";
// import AdminPanel from './Pages/AdminPanle';
// import LoginForm from './component/loginForm/LoginForm';

import { Helmet, HelmetProvider } from "react-helmet-async";

const App = () => {
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet>
          <title>هلیوم پارک اولین ترامپولین پارک ایران</title>
          <meta
            name="description"
            content="هلیوم پارک اولین ترامپولین پارک ایران در مشهد و تهران است که می توان یک روز پرهیجان و فوق العاد شاد را با دوستان و خانواده در آن سپری کرد."
          />
          <meta name="keywords" content="Fun With Numbers" />
          <meta name="author" content="Fun With Numbers" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/virtual" element={<Virtual />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/birthday" element={<BirthdayPage />} />
          <Route path="/comingsoon" element={<ComingSoon />} />
          <Route path="/login" element={<ComingSoon />} />
          <Route path="/admin/*" element={<ComingSoon />} />
          <Route path="/turning" element={<TurningPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </div>
  );
};
export default App;
